import { render, staticRenderFns } from "./SalesClientProducts.vue?vue&type=template&id=7c6ccc79"
import script from "./SalesClientProducts.vue?vue&type=script&lang=js"
export * from "./SalesClientProducts.vue?vue&type=script&lang=js"
import style0 from "./SalesClientProducts.vue?vue&type=style&index=0&id=7c6ccc79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports